// Vuetify — brand-tokenized configuration for the Banjino's DTC shop.
//
// We use Vuetify for layout primitives (grid, app shell), form orchestration
// (v-form, v-text-field with validation), and the gnarly interaction
// components (v-snackbar, v-dialog, v-progress-circular). The visible brand
// surfaces (buttons, cards, badges, modals) are custom Vue components under
// `src/components/banjino/` so the look-and-feel matches the static
// marketing site exactly. See shared/scss/foundation/_variables.scss for the
// canonical color values these tokens mirror.

import { createVuetify } from 'vuetify'
import { aliases, mdi } from 'vuetify/iconsets/mdi'

import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css'

import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

// Brand color tokens — these MUST match shared/scss/foundation/_variables.scss
const BRAND = {
  orange: '#EB661F',
  orangeDark: '#D35616',
  green: '#285338',
  greenDark: '#1a3524',
  tan: '#d8b767',
  burgundy: '#912e1a',
  olive: '#767934',
  cream: '#f4e5c1',
  surface: '#FFFCF5', // warm off-white
  error: '#D32F2F',
  success: '#4CAF50',
  warning: '#FF9800',
  info: '#2196F3'
}

export default createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: { mdi }
  },
  theme: {
    defaultTheme: 'banjino',
    themes: {
      banjino: {
        dark: false,
        colors: {
          primary: BRAND.orange,
          secondary: BRAND.green,
          accent: BRAND.tan,
          background: BRAND.surface,
          surface: '#ffffff',
          error: BRAND.error,
          info: BRAND.info,
          success: BRAND.success,
          warning: BRAND.warning,
          'on-primary': '#ffffff',
          'on-secondary': '#ffffff',
          'on-accent': BRAND.greenDark,
          'on-surface': '#2a2a2a',
          'on-background': '#2a2a2a'
        }
      }
    }
  },
  defaults: {
    global: {
      ripple: true
    },
    VBtn: {
      variant: 'flat',
      rounded: 'pill',
      style: 'text-transform: uppercase; letter-spacing: 0.05em; font-weight: 600;'
    },
    VTextField: {
      variant: 'outlined',
      density: 'comfortable',
      rounded: 'pill',
      color: 'primary'
    },
    VSelect: {
      variant: 'outlined',
      density: 'comfortable',
      rounded: 'pill',
      color: 'primary'
    },
    VTextarea: {
      variant: 'outlined',
      rounded: 'lg',
      color: 'primary'
    },
    VCheckbox: {
      color: 'primary',
      density: 'comfortable'
    },
    VRadio: {
      color: 'primary'
    },
    VAlert: {
      variant: 'tonal',
      density: 'comfortable',
      rounded: 'lg'
    },
    VCard: {
      rounded: 'lg',
      elevation: 0
    },
    VDialog: {
      transition: 'dialog-bottom-transition'
    },
    VProgressCircular: {
      color: 'primary'
    }
  }
})
